import {
  LuBusFront,
  LuLayoutPanelLeft,
  LuMap,
  LuMapPinned,
  LuTrafficCone,
  LuUser,
  LuUsers
} from 'react-icons/lu'

export const menuItems = [
  {
    title: 'Panel',
    slug: '/',
    parentSlug: null,
    active: true,
    roles: [1, 2],
    icon: (
      <LuLayoutPanelLeft
        className={`cursor-pointer float-left rounded-sm block`}
        size={26}
      />
    )
  },
  {
    title: 'Siniestro TUS',
    slug: '',
    parentSlug: null,
    active: true,
    roles: [1, 2],
    icon: (
      <LuTrafficCone
        className={`cursor-pointer float-left rounded-sm block`}
        size={26}
      />
    ),
    subMenuItems: [
      {
        title: 'Circulación',
        slug: '/tus-incidents/circulation/grid',
        parentSlug: '/tus-incidents/circulation',
        active: true,
        roles: [1, 2],
        icon: (
          <LuBusFront
            className={`cursor-pointer float-left rounded-sm block`}
            size={26}
          />
        ),
        subMenu: true
      },
      {
        title: 'Lesionados',
        slug: '/tus-incidents/injured/grid',
        parentSlug: '/tus-incidents/injured',
        active: true,
        roles: [1, 2],
        icon: (
          <LuUser
            className={`cursor-pointer float-left rounded-sm block`}
            size={26}
          />
        ),
        subMenu: true
      }
    ]
  },
  {
    title: 'Mapas',
    slug: '',
    parentSlug: null,
    active: true,
    roles: [1, 2],
    icon: (
      <LuMap
        className={`cursor-pointer float-left rounded-sm block`}
        size={26}
      />
    ),
    subMenuItems: [
      {
        title: 'Todos',
        slug: '/maps/all',
        parentSlug: '/maps-all',
        active: true,
        roles: [1, 2],
        icon: (
          <LuMapPinned
            className={`cursor-pointer float-left rounded-sm block`}
            size={26}
          />
        ),
        subMenu: true
      },
      {
        title: 'Circulación',
        slug: '/maps/circulation',
        parentSlug: '/maps/circulation',
        active: true,
        roles: [1, 2],
        icon: (
          <LuMapPinned
            className={`cursor-pointer float-left rounded-sm block`}
            size={26}
          />
        ),
        subMenu: true
      },
      {
        title: 'Lesionados',
        slug: '/maps/injured',
        parentSlug: '/maps/injured',
        active: true,
        roles: [1, 2],
        icon: (
          <LuMapPinned
            className={`cursor-pointer float-left rounded-sm block`}
            size={26}
          />
        ),
        subMenu: true
      }
    ]
  },
  {
    title: 'Usuarios',
    slug: '/users/grid',
    parentSlug: '/users',
    active: true,
    roles: [1],
    icon: (
      <LuUsers
        className={`cursor-pointer float-left rounded-sm block`}
        size={26}
      />
    )
  }
]
